module.exports = __webpack_public_path__ + "static/images/icon-indicator-dot-red.urvTA9R.svg";